import request from './request'

export function listProductionPerShift(data) {
  return request.post('/production/production-per-shifts/list', data)
}
export function getProductionPerShift(id) {
  return request.get('/production/production-per-shifts/' + id)
}
export function saveProductionPerShift(data) {
  return request.post('/production/production-per-shifts', data)
}
export function updateProductionPerShift(data) {
  return request.post('/production/production-per-shifts/update', data)
}
export function deleteProductionPerShift(ids) {
  return request.post('/production/production-per-shifts/delete', ids)
}
export function acceptProductionPerShift(ppsId) {
  return request.post('/production/production-per-shifts/accept', { ppsId })
}
